import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSqliteComponent } from './simple-icons-sqlite.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSqliteComponent ],
    exports:      [ SimpleIconsSqliteComponent ],
    bootstrap:    []
})
export class SimpleIconsSqliteModule {}
